/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pcr_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a reaction count and overage to scale the mix.`)
};

const es_pcr_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce un número de reacciones y un exceso para escalar la mezcla.`)
};

const de_pcr_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie eine Reaktionsanzahl und einen Überschuss ein, um den Mix zu skalieren.`)
};

const nl_pcr_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer een aantal reacties en overmaat in om de mix te schalen.`)
};

const fr_pcr_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez un nombre de réactions et une marge pour adapter le mix.`)
};

const it_pcr_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci il numero di reazioni e il margine di sicurezza per scalare la miscela.`)
};

const pt_br2_pcr_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe um número de reações e um excedente para dimensionar a mistura.`)
};

const pt_pcr_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza o número de reações e o excedente para escalar a mistura.`)
};

const ja_pcr_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`反応数とオーバーヘッジを入力してミックスをスケーリングしてください。`)
};

const zh_pcr_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入反应数量和损耗余量以放大配方。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pcr_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pcr_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pcr_hint", locale)
	if (locale === "en") return en_pcr_hint(inputs)
	if (locale === "es") return es_pcr_hint(inputs)
	if (locale === "de") return de_pcr_hint(inputs)
	if (locale === "nl") return nl_pcr_hint(inputs)
	if (locale === "fr") return fr_pcr_hint(inputs)
	if (locale === "it") return it_pcr_hint(inputs)
	if (locale === "pt-BR") return pt_br2_pcr_hint(inputs)
	if (locale === "pt") return pt_pcr_hint(inputs)
	if (locale === "ja") return ja_pcr_hint(inputs)
	return zh_pcr_hint(inputs)
};